import { MyCoursesSummaryInterface } from "../interfaces/my-courses-summary.interface";
import {
  RegisterCourses,
  RegisterCoursesResponse,
} from "../interfaces/register-courses.interface";
import http from "./axios";
import { downloadFile, handleError } from "./http-utils.service";

export const getCoursesSummaryByStudent = async (
  id: string,
): Promise<MyCoursesSummaryInterface[]> => {
  try {
    const response = await http.get<MyCoursesSummaryInterface[]>(
      `students-courses/${id}/courses-summary`,
    );
    return response.data;
  } catch (err) {
    throw handleError(err);
  }
};

export const downloadInvoiceRegistration = async (
  courseId: number,
  invoiceId: number,
): Promise<string> => {
  try {
    const response = await http.get<Blob>(
      `/students-courses/${courseId}/invoice/${invoiceId}/file`,
      {
        responseType: "blob",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    downloadFile(response.data, "invoice.pdf");
    return "success";
  } catch (e) {
    throw handleError(e);
  }
};

export const updateStudentCourse = async (
  update: RegisterCourses,
): Promise<RegisterCoursesResponse> => {
  try {
    const response = await http.patch<RegisterCoursesResponse>(
      `/students-courses/update-status/inprogress`,
      update,
    );
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};

export const downloadLetterCertificateFile = async (
  courseId: number,
  type: string,
): Promise<string> => {
  const name =
    type === "certificate"
      ? "SEABC Certificate.pdf"
      : "SEABC Completion Letter.pdf";
  try {
    const response = await http.get<Blob>(`/courses/${courseId}/${type}`, {
      responseType: "blob",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    });
    downloadFile(response.data, name);
    return "success";
  } catch (e) {
    throw handleError(e);
  }
};
